module.exports = __webpack_public_path__ + "img/1.44684cc5.png";